module.exports = require("react-redux");


/*****************
 ** WEBPACK FOOTER
 ** external "react-redux"
 ** module id = 36
 ** module chunks = 0
 **/